import styled from 'styled-components';

export const Card = styled.div`
  background: linear-gradient(135.17deg, #1d1433 0%, #2b1d50 100%);
  border-radius: 24px;
  padding: 24px;
  color: #ffffff;
  position: relative;
  margin: 0 16px 20px;
  min-height: 150px;
`;

export const Text = styled.p`
  margin: 0;
  font-family: Playfair Display;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 2%;
`;

const Logo = styled.img`
  position: absolute;
  bottom: 16px;
  left: 24px;
`;

export const QuoteImg = styled.img`
  position: absolute;
  bottom: 16px;
  right: 24px;
`;

export const LogoSmall = styled(Logo)`
  width: 91px;
  height: 32px;
`;

export const LogoMedium = styled(Logo)`
  width: 116px;
  height: 32px;
`;

export const LogoLarge = styled(Logo)`
  width: 167px;
  height: 23px;
`;
